import request from '@/utils/request'

export function getApi(params) {
  return request({
    url: '/open/list',
    method: 'get',
    params
  })
}

export function addApi(data) {
  return request({
    url: '/open/api',
    method: 'post',
    data
  })
}

export function deleteApi(params) {
  return request({
    url: '/open/api',
    method: 'delete',
    params
  })
}

export function changeApi(data) {
  return request({
    url: '/open/api',
    method: 'PUT',
    data
  })
}

export function getaksk() {
  return request({
    url: '/open/hmac',
    method: 'get'
  })
}
